<template>
    <div>
      <canvas ref="bubbleCanvas" width="70" height="70"></canvas>
    </div>
  </template>
  
  <script>
  export default {
    mounted() {
      this.drawBubbleLevel(this.angleXInDegrees, this.angleYInDegrees); // 초기에는 기본 각도로 그림
      window.addEventListener("deviceorientation", this.handleOrientation);
    },
    unmounted() {
      window.removeEventListener("deviceorientation", this.handleOrientation);
    },
    data() {
      return {
        // angleXInDegrees: 0,
        // angleYInDegrees: 0,
      };
    },
    props: {
        angleXInDegrees: {
        type: Number,
        required: true,
        },
        angleYInDegrees: {
        type: Number,
        required: true,
        },
    },
    methods: {
      drawBubbleLevel(angleX, angleY) {
        const canvas = this.$refs.bubbleCanvas;
        const ctx = canvas.getContext("2d");
  
        const centerX = canvas.width / 2;
        const centerY = canvas.height / 2;
        const bubbleRadius = 5;
  
        ctx.clearRect(0, 0, canvas.width, canvas.height);
  
        // Draw the crosshair lines
        ctx.beginPath();
        ctx.moveTo(centerX, 0);
        ctx.lineTo(centerX, canvas.height);
        ctx.moveTo(0, centerY);
        ctx.lineTo(canvas.width, centerY);
        ctx.strokeStyle = "black";
        ctx.stroke();
  
        // Calculate the bubble's position based on x and y angles
        const bubbleX = centerX + (canvas.width - 2 * bubbleRadius) * Math.sin(angleX/180*Math.PI/2);
        const bubbleY = centerY + (canvas.height - 2 * bubbleRadius) * Math.sin(angleY/180*Math.PI/2);
  
        // Draw the bubble
        ctx.beginPath();
        ctx.arc(bubbleX, bubbleY, bubbleRadius, 0, 2 * Math.PI);
        ctx.fillStyle = "blue";
        ctx.fill();
        ctx.strokeStyle = "black";
        ctx.stroke();
      },
    //   handleOrientation(event) {
    //     // Use the gamma value for the x angle and beta value for the y angle
    //     this.angleXInDegrees = event.gamma || 0;
    //     this.angleYInDegrees = event.beta || 0;
    //     this.drawBubbleLevel(this.angleXInDegrees, this.angleYInDegrees);
    //   },

    },
    watch: {
        angleXInDegrees(newAngle) {
            this.drawBubbleLevel(newAngle, this.angleYInDegrees);
        },
        angleYInDegrees(newAngle) {
            this.drawBubbleLevel(this.angleXInDegrees, newAngle);
        },
    },
  };
  </script>
  
  <style>
  canvas {
    border: 1px solid black;
  }
  </style>
  